<template>
    <!-- TODO: mobile header not visible on mobile -->
    <div class="auth-dialog__mobile-header auth-dialog__mobile-header__gradient-element" v-if="isMobileDevice"></div>
    <div class="auth-dialog__mobile-header auth-dialog__mobile-header__background-element" v-if="isMobileDevice"></div>
</template>



<script setup lang="ts">

import { isMobile } from '@/utils/utils';
const isMobileDevice = isMobile();

</script>